import { api } from './api';
import { Aniversariante, AniversarioMensagem } from '../types/aniversariantes';

export async function listAniversariantesMes(mes?: number): Promise<Aniversariante[]> {
  const params = mes !== undefined ? { mes } : {};
  const response = await api.get('/aniversariantes', { params });
  return response.data;
}

export async function enviarMensagemAniversario(
  id_militar_destinatario: string,
  mensagem: string
): Promise<AniversarioMensagem> {
  const response = await api.post(`/aniversariantes/${id_militar_destinatario}/mensagens`, {
    mensagem,
  });
  return response.data;
}

export async function listarDestinatariosComMensagens(): Promise<{ id_militar_destinatario: string; total: number }[]> {
  const response = await api.get('/aniversariantes/mensagens/destinatarios');
  return response.data;
}

export async function listarMensagensAniversario(
  id_militar_destinatario: string
): Promise<AniversarioMensagem[]> {
  const response = await api.get(`/aniversariantes/${id_militar_destinatario}/mensagens`);
  return response.data;
}
